import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Flex,
  Heading,
  Spacer,
  Stack,
  StackDivider,
  Tag,
} from "@chakra-ui/react";

import { getZohoClients, getTaskList } from "api/requests/zohoRequests";
import { useState } from "react";

function ZohoAuth() {
  const [zohoClients, setZohoClients] = useState([]);
  const [zohoTaskLists, setZohoTaskLists] = useState([]);

  const fetchZohoClients = async () => {
    try {
      const data = await getZohoClients();
      setZohoClients(data);
      console.log("Clients:", data);
    } catch (error) {
      console.error("Failed to fetch clients:", error);
    }
  };

  const fetchTaskLists = async () => {
    try {
      const data = await getTaskList();
      setZohoTaskLists(data);
      console.log("Task Lists:", data);
    } catch (error) {
      console.error("Failed to fetch Task Lists:", error);
    }
  };

  return (
    <Stack pt={{ base: "150px", lg: "75px" }}>
      <Card>
        <CardHeader>
          <Heading size={"md"}>Zoho CRM API</Heading>
        </CardHeader>
        <CardBody>
          <Stack divider={<StackDivider />} spacing={4}>
            <Flex alignItems={"center"} gap={"2"}>
              <Box p={2}>
                <Heading size={"sm"}>
                  Connection Status: <Tag colorScheme={"green"}>Active</Tag>
                </Heading>
              </Box>
              <Spacer />
              <ButtonGroup gap={"2"}>
                <Button colorScheme={"green"}>Connect</Button>
                <Button colorScheme={"red"}>Disconnect</Button>
              </ButtonGroup>
            </Flex>
          </Stack>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <Heading size={"md"}>Zoho Projects API</Heading>
        </CardHeader>
        <CardBody>
          <Stack divider={<StackDivider />} spacing={4}>
            <Flex alignItems={"center"} gap={"2"}>
              <Box p={2}>
                <Heading size={"sm"}>
                  Connection Status: <Tag colorScheme={"green"}>Active</Tag>
                </Heading>
              </Box>
              <Spacer />
              <ButtonGroup gap={"2"}>
                <Button colorScheme={"green"}>Connect</Button>
                <Button colorScheme={"red"}>Disconnect</Button>
              </ButtonGroup>
            </Flex>
          </Stack>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <Heading size={"md"}>Testing Area</Heading>
        </CardHeader>
        <CardBody>
          <Stack divider={<StackDivider />} spacing={4}>
            <Flex alignItems={"center"} gap={"2"}>
              <ButtonGroup gap={"2"}>
                <Button colorScheme={"blue"} onClick={() => fetchZohoClients()}>
                  Get CRM Client list
                </Button>
                <Button colorScheme={"blue"} onClick={() => fetchTaskLists()}>
                  Get Task Template List
                </Button>
              </ButtonGroup>
            </Flex>
          </Stack>
        </CardBody>
      </Card>
    </Stack>
  );
}

export default ZohoAuth;
